import { getCurrentLang, getCurrentLangDirection } from '../../language/langSwitcher';
import {addCloseBtn, addHeader, createHtmlElement} from '../../../functions';
import { pageResize } from '../../menu/menu';
import {isMobile, settingsData} from '../../../settings';
import { Swipe } from '../poi/poiv3';
import { desktopErrorIcon } from '../widgets';

const canvasClass = 'bmby-about-wrapp';
let aboutUsMainContainer;
let lang, dir, isData, activeTabInd, crmData;

export function aboutWidgetInit(crm){
    lang = getCurrentLang();
    dir = getCurrentLangDirection();

    const mainContainer = createHtmlElement(document.body,'','div',['widget__container']);
    mainContainer.dataset.menuItem = 'about';
    aboutUsMainContainer = createHtmlElement(mainContainer,'','div',[`${canvasClass}`, `${dir}`]);
    mainContainer.style.visibility = 'hidden';
    mainContainer.style.opacity = 0;
    mainContainer.style.paddingTop = settingsData.widgetsPaddingTop + 'px';

    isData = checkCRM(crm);
    if (!isData){
        showErrorPage();
        pageResize(mainContainer);
        return;
    }

    crmData = crm.data;
    activeTabInd =  isData ? crm.data[0].order : 0;

    // aboutUsMainContainer.dataset.menuItem = 'about';

    const userAgent = checkUserAgent();
    if (userAgent && userAgent !== 'Windows'){
        reduceImage(crm.data);
    }

    insertMenu(activeTabInd,crm.data);
    // orientationHandler();
    cropImageToText();

    pageResize(mainContainer);

    if (isMobile) {
        addHeader(mainContainer, 'about');
        addCloseBtn(mainContainer);
    }
    // window.addEventListener('orientationchange', orientationHandler);
}

function cropImageToText() {
    if (window.innerWidth >= 1024){
        const sectionCollection = document.querySelectorAll('.tab-content__container-section');
        sectionCollection.forEach(section => {
            setTimeout(() => {
                const img = section.querySelector('.about-us__img-container > .tab-content__image');
                const sub = section.querySelector('.text-content__wrapper > .about-us__sub-wrapper');
                let subHeight = 0;
                for (let child of sub.children) {
                    subHeight += child.getBoundingClientRect().height;
                }
                if (img.getBoundingClientRect().height > subHeight + 120) {
                    img.style.height = subHeight + 120 + 'px';
                }
            }, 50);
        });
    }
}

function checkUserAgent () {
    let userAgentData;
    const userAgentArr = ['iPhone','iPad','Android','Windows'];
    const userAgent = window.navigator.userAgent;
    userAgentArr.forEach(agent =>{
        const res = userAgent.match(agent);
        if (res){
            userAgentData = res[0];
        }
    });
    return userAgentData;
}

function orientationHandler() {
    setTimeout(()=>{
        const isPortrait = isWindowInPortrait();
        if (window.innerWidth < 1024) {
            clearContent();
            if (!isData){
                showErrorPage();
                return;
            }
            insertMenu(activeTabInd);
        } else {
            clearContent();
            insertMenu(activeTabInd);
        }
    }, 250);
}

function clearContent() {
    while (aboutUsMainContainer.firstChild) {
        aboutUsMainContainer.removeChild(aboutUsMainContainer.firstChild);
    }
}

export function aboutUpdate () {
    lang = getCurrentLang();
    dir = getCurrentLangDirection();

    if (!aboutUsMainContainer){
        return;
    }

    const errorPage = aboutUsMainContainer.querySelector('.error-page__wrapper');
    if (errorPage){
        return;
    }

    clearContent();
    aboutUsMainContainer.classList.remove('rtl');
    aboutUsMainContainer.classList.remove('ltr');
    aboutUsMainContainer.classList.add(dir);
    pageResize(aboutUsMainContainer.parentElement);
    insertMenu(activeTabInd,crmData);
}


function reduceImage (aboutData) {
    const reduceImgUrl = 'cdn-cgi/image/width=800';
    aboutData.forEach(data=>{
       data.sections.forEach(section =>{
           if (section.imageUrl.length>0){
               const parseUrl = section.imageUrl.replace('https://','').split('/');
               parseUrl.unshift('https:/');
               parseUrl.splice(2,0,reduceImgUrl);
               const buildUrl = parseUrl.join('/');
               section.imageUrl = buildUrl;
           }
       });
    });
}

function insertMenu(activeTab = 0, data) {
    let tabsDataMainContainer;

    const menuWrapper = createHtmlElement('','','div',['menu-content__wrapper']);
    const menuContainer = createHtmlElement(menuWrapper, '', 'ul', ['about__menu__items']);
    aboutUsMainContainer.insertAdjacentElement('afterbegin', menuWrapper);

    const isTabWrapperExist = aboutUsMainContainer.querySelector('.tabs-data-content__wrapper');
    if (!isTabWrapperExist) {
        tabsDataMainContainer = createHtmlElement(aboutUsMainContainer, '', 'div', ['tabs-data-content__wrapper']);
    } else {
        tabsDataMainContainer = isTabWrapperExist;
    }
    data.forEach((menuElement, index) => {
        if (menuElement.sections.length){
            let chapter = menuElement.chapter.filter(el => el.lang === lang);
            if (!chapter[0].hasOwnProperty('value')) {
                throw 'menuElement has unsupported structure';
            }
            const li = createHtmlElement(menuContainer, chapter[0].value, 'li', ['menu__item']);
            li.dataset.order = menuElement.order;
            buildTabsContent(tabsDataMainContainer, menuElement,data);
        }
    });
    const menuElementOrder = document.querySelector('.menu__item[data-order="' + activeTab + '"]');
    switchTab(menuElementOrder);
    activeTabInd = activeTab;

    createHtmlElement(menuContainer, '', 'div', ['menu__plug']);
    setMenuStyle(menuContainer);
    menuContainer.addEventListener('click', (e) => switchTab(e.target));
    const swipe = new Swipe(tabsDataMainContainer,true);

    swipe.stop();
    swipe.onLeft(()=> swipeTabsContent(data,swipe));
    swipe.onRight(()=> swipeTabsContent(data,swipe));
    swipe.onDown(()=>{});
    swipe.onUp(()=> {});
    swipe.run();
}

function swipeTabsContent(data, swipe) {
    if (data.length > 1){

        const activeMenu = getActiveTabMenu();
        const direction = swipe.getDirection();

        switch (direction) {
            case dir === 'rtl' ? 'right' : 'left':
                const nexElement = activeMenu.parentElement.querySelector('.menu__item[data-order="' + (Number(activeMenu.dataset.order) + 1) + '"]');
                if (nexElement) {
                    switchTab(nexElement);
                }
                break;
            case dir === 'rtl' ? 'left' : 'right':
                const prevElement = activeMenu.parentElement.querySelector('.menu__item[data-order="' + (Number(activeMenu.dataset.order) - 1) + '"]');
                if (prevElement) {
                    switchTab(prevElement);
                }
                break;
        }

    }
}

function getActiveTabMenu() {
    let activeMenu;
    const menuCollection = document.querySelectorAll('.menu__item');
    menuCollection.forEach(menu => {
        if (menu.classList.contains('about-active')) {
            activeMenu = menu;
        }
    });
    return activeMenu;
}

function isWindowInPortrait() {
    return window.matchMedia("(orientation: portrait)").matches;
}

function setMenuStyle(menuItems) {
    const isPortrait = isWindowInPortrait();
    const childrenItems = menuItems.children;
    const lengthItems = menuItems.children.length;
    const scrollWidth = menuItems.scrollWidth;
    const currentView = menuItems.offsetWidth;

    if (isPortrait) {
        if (scrollWidth <= currentView && lengthItems > 2) {
            menuItems.style.justifyContent = 'space-between';
            for (let child of childrenItems) {
                child.style.flexBasis = 100 / (lengthItems - 1) + '%';
                child.style.textAlign = 'center';
            }
        }
    }
}

function buildTabsContent(container, objectContent, data) {
    const tab = createHtmlElement(container, '', 'div', ['tab-content__container']);
    objectContent.sections.forEach(sectionData => {
        // this is the DOM element that contains the section content
        let section = createHtmlElement(tab, '', 'div', ['tab-content__container-section']);
        tab.dataset.order = objectContent.order;

        const textWrapper = createHtmlElement(section,'','div',['text-content__wrapper']);
        const subWrapper = createHtmlElement(textWrapper,'','div',['about-us__sub-wrapper']);

            if (sectionData.title.filter(el => el.lang === lang)[0].value.length > 0){
                let title = createHtmlElement(subWrapper, sectionData.title.filter(el => el.lang === lang)[0].value, 'h3', ['tab-content__title']);
            }

        const text = createHtmlElement(subWrapper, sectionData.description.filter(el => el.lang === lang)[0].value, 'p', ['tab-content__text']);

        const imgContainer = createHtmlElement(section, '', 'div', ['about-us__img-container']);
        const img = createHtmlElement(imgContainer, '', 'img', ['tab-content__image']);
        img.src = sectionData.imageUrl;

        if (objectContent.order !== 0) {
            if (data.length > 1){
                tab.classList.add('hide-tab');
            }
        }
    });
}

function toggleTabContent(tabOrder) {
    const tabsContentCollection = document.querySelectorAll('.tab-content__container');
    tabsContentCollection.forEach(tab => {
        if (tab.dataset.order === tabOrder) {
            tab.classList.remove('hide-tab');
        } else {
            tab.classList.add('hide-tab');
        }
    });

}

function switchTab(e) {
    if(e === null){
        return;
    }
    const parent = e.parentElement;
    if (e.classList.contains('menu__item')) {
        setActiveTab(parent, e);
        activeTabInd = e.dataset.order;
        toggleTabContent(e.dataset.order);
        cropImageToText();
    }
}

function setActiveTab(parent, e) {
    const menuItemsCollection = parent.querySelectorAll('.menu__item');
    menuItemsCollection.forEach(menu => {
        if (e === menu) {
            menu.classList.add('about-active');
        } else {
            menu.classList.remove('about-active');
        }
    });
}

function checkCRM (crm) {
    if (crm.data.length){
        const sections = crm.data.filter(el=>el.sections.length);
        return !!sections.length;
    } else {
        return false;
    }
}

function showErrorPage () {
    const mainContainer = document.querySelector('.'+canvasClass);
    const wrapper = createHtmlElement(mainContainer,'','div',['error-page__wrapper']);
    const icon = createHtmlElement(wrapper,'','div',['error-page__icon']);
    icon.innerHTML = desktopErrorIcon;
    const text = createHtmlElement(wrapper,'The page is under construction','h1',['error-page__title']);
}
